import { styled } from '@mui/material';
import MuiGrid from '@mui/material/Grid';
import { compose, palette, sizing, spacing } from '@mui/system';

export const Grid = styled(MuiGrid)(compose(palette, spacing, sizing));
